import { ActionReducerMap } from '@ngrx/store';
import {
  coreReducer,
  CoreState,
} from './core.reducer';

export interface ApplicationState {
  core: CoreState,
}

export const state: ActionReducerMap<ApplicationState> = {
  core: coreReducer,
};
